import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import {environment} from '../../../environments/environment';

export class Debt{
  id?: string;
  assetId?: string;
  ownerId?: string;
  principalBorrowed: number;
  principalPayoutAt: Date;
  durationMonths: number;
  name: string;
  isExploratory: boolean;

  constructor() {
    this.principalBorrowed = 0;
    this.principalPayoutAt = new Date();
    this.durationMonths = 0;
    this.name = "";
    this.isExploratory = true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class DebtsService {
  private baseApi: string = environment.apiUrl + "/debts/";
  constructor(private http: HttpClient) { }

  public getDebts(): Observable<Debt[]> {
    return this.http.get<Debt[]>(this.baseApi)
    .pipe(catchError(this.handleError));
  }

  public getDebt(debtId: string): Observable<Debt> {
    return this.http.get<Debt>(this.baseApi + debtId)
    .pipe(catchError(this.handleError));
  }

  public getDebtsByAsset(assetId: string): Observable<Debt[]> {
    return this.http.get<Debt[]>(this.baseApi + "?assetId=" + assetId)
    .pipe(catchError(this.handleError));
  }

  public createDebt(debt: Debt):Observable<Debt> {
    return this.http.post<Debt>(this.baseApi, debt)
    .pipe(catchError(this.handleError));
  }

  public updateDebt(debt: Debt):Observable<Debt> {
    return this.http.put<Debt>(this.baseApi + debt.id, debt)
    .pipe(catchError(this.handleError));
  }

  public deleteDebt(debt: Debt):Observable<Debt> {
    return this.http.delete<Debt>(this.baseApi + debt.id)
    .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
